/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import PropTypes from '../util/prop_types';
import { MapActionCreators } from '../stores/map_action_creators';
import { MapSelectors } from '../stores/map_selectors';

const mapStateToProps = (state) => {
  return {
    mapActions: MapSelectors.getActions(state),
  }
}

const mapDispatchToProps = {
  deleteMapActions: MapActionCreators.deleteActions,
};

class MapActions extends React.Component {
  static propTypes = {
    mapActions: PropTypes.immutable.map,
    deleteMapActions: PropTypes.func.isRequired,
  }

  static contextTypes = {
    map: PropTypes.object,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.mapActions.count() > 0) {
      let actionsToDelete = [];
      nextProps.mapActions.forEach((action, id) => {
        const actionType = action.get('actionType');
        const params = action.get('params');

        switch (actionType) {
          case "setLayoutProperty": {
            this.context.map.setLayoutProperty(params.layer, params.name, params.value)
            break;
          }
        }

        actionsToDelete.push(id);
      });

      if (actionsToDelete.length > 0) {
        nextProps.deleteMapActions(actionsToDelete);
      }
    }
  }

  render(): ?React.Element<any> {
    return null;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapActions);
